import { AccessoryModel, CalculationType, CouponModel, EngineType, HubBikeModel, TimeZones, VehicleType, VendorModel, VendorType } from "../components/utils/Models"

// App config
export const Urls = {
  APP_BASE: process.env.REACT_APP_BASE_API_URL,
  MAIN_SITE: process.env.REACT_APP_MAIN_SITE_URL,
  STATIC_SITE: process.env.REACT_APP_STATIC_SITE_URL
}

// Slice names for redux toolkit
export enum SliceNames {
  LOGIN_INFO = 'LOGIN_INFO',
  NAV_SELECTION_INDEX = 'NAV_SELECTION_INDEX',
  HUB_SELECTION_DATA = 'HUB_SELECTION_DATA',
  VENDOR_PROFILE = 'VENDOR_PROFILE'
}
export enum NavTabIndices {
  HOME,
  DASHBOARD,
  BOOKINGS,
  REVIEWS,
  BIKES,
  ACCESSORIES,
  BLOCKS,
  LEDGER,
  OFFERS,
  TICKETS,
  PROFILE
}
export enum NavTabLinks {
  BOOKINGS = '/bookings'
}
export const DefaultSliceData = {
  NAV_SELECTION_INDEX: NavTabIndices.HOME,
  HUB_SELECTION_INDEX: 0,
  VENDOR_PROFILE: {
    id: -1,
    cityId: -1,
    regStatus: false,
    activeStatus: false,
    adminBlocked: false,
    name: '',
    username: '',
    company: '',
    phone: '',
    email: '',
    vendorType: VendorType.INDIVIDUAL,
    timezone: TimeZones.INDIA,
    split: 0,
    priceCalculation: {
      calcType: CalculationType.DAILY
    },
    onCashfree: false,
    accountVerified: false,
  } as VendorModel,
  VENDOR_HUBS: [
    { landmark: 'INA Metro' },
    { landmark: 'Govindpuri' },
  ],
  DUMMY_BIKE: {
    bikes: [],
    prices: {},
    deposit: 0,
    quantity: 0,
    activeQuantity: 0,
    availability: {},
    distanceLimits: 0,
    speedLimit: 0,
    penalty: 0,
    tnc: [],
    bike: {
      id: -1,
      name: '',
      brand: '',
      image: '',
      mileage: 0,
      topSpeed: 0,
      vehicleType: VehicleType.BIKE,
      engineType: EngineType.PETROL
    },
  } as HubBikeModel,
  DUMMY_ACCESSORY: {
    id: -1,
    hub_accessories: {
      accessoryId: -1,
      prices: {},
      availability: {},
    }
  } as AccessoryModel,
  DUMMY_OFFER: {

  } as CouponModel
}

// Gobikes theme colors
export const Colors = {
  primary: '#8dbe2e',
  primaryDark: '#78a225',
  successGreen: '#1dab1d',
  warningYellow: '#b3990e',
  warningButton: '#fbf2c1',
  failureRed: '#cb0000',
  greyLight1: '#fafafa',
  greyLight2: '#f7f7f7',
  greyDark1: '#444',
  greyDark2: '#777',
  greyDark3: '#aaa',
  toastSuccessText: '#155724',
  toastFailureText: '#721c24',
  toastWarningText: '#856404',
  toastSuccessBg: '#d4edda',
  toastFailureBg: '#f8d7da',
  toastWarningBg: '#fff3cd',
  toastSuccessBorder: '#c3c6cb',
  toastFailureBorder: '#f5c6cb',
  toastWarningBorder: '#ffeeba'
}

export const Time = {
  MINUTE: 60000,
  HOUR: 3600000,
  DAY: 86400000
};

// export const Colors = {
//   primary: '#9c3',
//   primaryDark: '#8dbe2e'
// }

// Defaul loader styles
export const DEFAULT_LOADER_STYLES = {
  containerSx: {
    mt: { xs: 0, md: '40px' },
    width: { xs: '100%', md: 'calc(100% - 40px)' },
    height: { xs: '70vh', md: 'calc(100vh - 580px)' },
    paddingTop: { xs: '30vh', md: '400px' }
  }
}

// Dashboard icons
export const DashboardIconImageLinks = {
  BOOKINGS: '7a9c5300-5450-4999-8a71-3fe874f35d5a.png',
  DASHBOARD: '0a63b6be-4b14-4a4a-95a5-cb9ac0ce1875.png',
  PROFILE: 'd6ed00dd-b6c7-4499-ae75-fe0fed1d2f4c.png',
  LEDGER: '7fbcb622-710c-4b83-90bc-74e3f3b03f01.png',
  REVIEWS: '5d23499d-eda0-4945-8764-730660beff3f.png',
  KYC: 'be6302c4-5084-46ad-a83a-c358a8cc41e2.png',
  OFFERS: '71df01ce-75b2-497a-8d4c-24915dc4e5fc.png',
  BLOCK_VEHICLES: 'af183efb-867a-4d36-b664-ad87de35a63f.png',
  VEHICLES: '5ca99911-a62a-4e88-b185-91632c3b6e4c.png',
  ACCESSORIES: 'bf5b48db-752a-4b8f-9f95-42218b111327.png',
  HELP: '441245ce-165b-4d69-bd0d-b389167f3741.png'
}

// Country codes list
export const DefaultCountryCode = "+91";
export const CountryCodesList = [
  {
    'code': 'IN',
    'value': '+91',
    'display': 'India (+91)'
  },
  {
    'code': 'BD',
    'value': '+880',
    'display': 'Bangladesh (+880)'
  },
  {
    'code': 'BE',
    'value': '+32',
    'display': 'Belgium (+32)'
  },
  {
    'code': 'BF',
    'value': '+226',
    'display': 'Burkina Faso (+226)'
  },
  {
    'code': 'BG',
    'value': '+359',
    'display': 'Bulgaria (+359)'
  },
  {
    'code': 'BA',
    'value': '+387',
    'display': 'Bosnia and Herzegovina (+387)'
  },
  {
    'code': 'BB',
    'value': '+1-246',
    'display': 'Barbados (+1-246)'
  },
  {
    'code': 'WF',
    'value': '+681',
    'display': 'Wallis and Futuna (+681)'
  },
  {
    'code': 'BL',
    'value': '+590',
    'display': 'Saint Barthelemy (+590)'
  },
  {
    'code': 'BM',
    'value': '+1-441',
    'display': 'Bermuda (+1-441)'
  },
  {
    'code': 'BN',
    'value': '+673',
    'display': 'Brunei (+673)'
  },
  {
    'code': 'BO',
    'value': '+591',
    'display': 'Bolivia (+591)'
  },
  {
    'code': 'BH',
    'value': '+973',
    'display': 'Bahrain (+973)'
  },
  {
    'code': 'BI',
    'value': '+257',
    'display': 'Burundi (+257)'
  },
  {
    'code': 'BJ',
    'value': '+229',
    'display': 'Benin (+229)'
  },
  {
    'code': 'BT',
    'value': '+975',
    'display': 'Bhutan (+975)'
  },
  {
    'code': 'JM',
    'value': '+1-876',
    'display': 'Jamaica (+1-876)'
  },
  {
    'code': 'BV',
    'value': '+',
    'display': 'Bouvet Island (+)'
  },
  {
    'code': 'BW',
    'value': '+267',
    'display': 'Botswana (+267)'
  },
  {
    'code': 'WS',
    'value': '+685',
    'display': 'Samoa (+685)'
  },
  {
    'code': 'BQ',
    'value': '+599',
    'display': 'Bonaire, Saint Eustatius and Saba  (+599)'
  },
  {
    'code': 'BR',
    'value': '+55',
    'display': 'Brazil (+55)'
  },
  {
    'code': 'BS',
    'value': '+1-242',
    'display': 'Bahamas (+1-242)'
  },
  {
    'code': 'JE',
    'value': '+44-1534',
    'display': 'Jersey (+44-1534)'
  },
  {
    'code': 'BY',
    'value': '+375',
    'display': 'Belarus (+375)'
  },
  {
    'code': 'BZ',
    'value': '+501',
    'display': 'Belize (+501)'
  },
  {
    'code': 'RU',
    'value': '+7',
    'display': 'Russia (+7)'
  },
  {
    'code': 'RW',
    'value': '+250',
    'display': 'Rwanda (+250)'
  },
  {
    'code': 'RS',
    'value': '+381',
    'display': 'Serbia (+381)'
  },
  {
    'code': 'TL',
    'value': '+670',
    'display': 'East Timor (+670)'
  },
  {
    'code': 'RE',
    'value': '+262',
    'display': 'Reunion (+262)'
  },
  {
    'code': 'TM',
    'value': '+993',
    'display': 'Turkmenistan (+993)'
  },
  {
    'code': 'TJ',
    'value': '+992',
    'display': 'Tajikistan (+992)'
  },
  {
    'code': 'RO',
    'value': '+40',
    'display': 'Romania (+40)'
  },
  {
    'code': 'TK',
    'value': '+690',
    'display': 'Tokelau (+690)'
  },
  {
    'code': 'GW',
    'value': '+245',
    'display': 'Guinea-Bissau (+245)'
  },
  {
    'code': 'GU',
    'value': '+1-671',
    'display': 'Guam (+1-671)'
  },
  {
    'code': 'GT',
    'value': '+502',
    'display': 'Guatemala (+502)'
  },
  {
    'code': 'GS',
    'value': '+',
    'display': 'South Georgia and the South Sandwich Islands (+)'
  },
  {
    'code': 'GR',
    'value': '+30',
    'display': 'Greece (+30)'
  },
  {
    'code': 'GQ',
    'value': '+240',
    'display': 'Equatorial Guinea (+240)'
  },
  {
    'code': 'GP',
    'value': '+590',
    'display': 'Guadeloupe (+590)'
  },
  {
    'code': 'JP',
    'value': '+81',
    'display': 'Japan (+81)'
  },
  {
    'code': 'GY',
    'value': '+592',
    'display': 'Guyana (+592)'
  },
  {
    'code': 'GG',
    'value': '+44-1481',
    'display': 'Guernsey (+44-1481)'
  },
  {
    'code': 'GF',
    'value': '+594',
    'display': 'French Guiana (+594)'
  },
  {
    'code': 'GE',
    'value': '+995',
    'display': 'Georgia (+995)'
  },
  {
    'code': 'GD',
    'value': '+1-473',
    'display': 'Grenada (+1-473)'
  },
  {
    'code': 'GB',
    'value': '+44',
    'display': 'United Kingdom (+44)'
  },
  {
    'code': 'GA',
    'value': '+241',
    'display': 'Gabon (+241)'
  },
  {
    'code': 'SV',
    'value': '+503',
    'display': 'El Salvador (+503)'
  },
  {
    'code': 'GN',
    'value': '+224',
    'display': 'Guinea (+224)'
  },
  {
    'code': 'GM',
    'value': '+220',
    'display': 'Gambia (+220)'
  },
  {
    'code': 'GL',
    'value': '+299',
    'display': 'Greenland (+299)'
  },
  {
    'code': 'GI',
    'value': '+350',
    'display': 'Gibraltar (+350)'
  },
  {
    'code': 'GH',
    'value': '+233',
    'display': 'Ghana (+233)'
  },
  {
    'code': 'OM',
    'value': '+968',
    'display': 'Oman (+968)'
  },
  {
    'code': 'TN',
    'value': '+216',
    'display': 'Tunisia (+216)'
  },
  {
    'code': 'JO',
    'value': '+962',
    'display': 'Jordan (+962)'
  },
  {
    'code': 'HR',
    'value': '+385',
    'display': 'Croatia (+385)'
  },
  {
    'code': 'HT',
    'value': '+509',
    'display': 'Haiti (+509)'
  },
  {
    'code': 'HU',
    'value': '+36',
    'display': 'Hungary (+36)'
  },
  {
    'code': 'HK',
    'value': '+852',
    'display': 'Hong Kong (+852)'
  },
  {
    'code': 'HN',
    'value': '+504',
    'display': 'Honduras (+504)'
  },
  {
    'code': 'HM',
    'value': '+ ',
    'display': 'Heard Island and McDonald Islands (+ )'
  },
  {
    'code': 'VE',
    'value': '+58',
    'display': 'Venezuela (+58)'
  },
  {
    'code': 'PR',
    'value': '+1-787 and 1-939',
    'display': 'Puerto Rico (+1-787 and 1-939)'
  },
  {
    'code': 'PS',
    'value': '+970',
    'display': 'Palestinian Territory (+970)'
  },
  {
    'code': 'PW',
    'value': '+680',
    'display': 'Palau (+680)'
  },
  {
    'code': 'PT',
    'value': '+351',
    'display': 'Portugal (+351)'
  },
  {
    'code': 'SJ',
    'value': '+47',
    'display': 'Svalbard and Jan Mayen (+47)'
  },
  {
    'code': 'PY',
    'value': '+595',
    'display': 'Paraguay (+595)'
  },
  {
    'code': 'IQ',
    'value': '+964',
    'display': 'Iraq (+964)'
  },
  {
    'code': 'PA',
    'value': '+507',
    'display': 'Panama (+507)'
  },
  {
    'code': 'PF',
    'value': '+689',
    'display': 'French Polynesia (+689)'
  },
  {
    'code': 'PG',
    'value': '+675',
    'display': 'Papua New Guinea (+675)'
  },
  {
    'code': 'PE',
    'value': '+51',
    'display': 'Peru (+51)'
  },
  {
    'code': 'PK',
    'value': '+92',
    'display': 'Pakistan (+92)'
  },
  {
    'code': 'PH',
    'value': '+63',
    'display': 'Philippines (+63)'
  },
  {
    'code': 'PN',
    'value': '+870',
    'display': 'Pitcairn (+870)'
  },
  {
    'code': 'PL',
    'value': '+48',
    'display': 'Poland (+48)'
  },
  {
    'code': 'PM',
    'value': '+508',
    'display': 'Saint Pierre and Miquelon (+508)'
  },
  {
    'code': 'ZM',
    'value': '+260',
    'display': 'Zambia (+260)'
  },
  {
    'code': 'EH',
    'value': '+212',
    'display': 'Western Sahara (+212)'
  },
  {
    'code': 'EE',
    'value': '+372',
    'display': 'Estonia (+372)'
  },
  {
    'code': 'EG',
    'value': '+20',
    'display': 'Egypt (+20)'
  },
  {
    'code': 'ZA',
    'value': '+27',
    'display': 'South Africa (+27)'
  },
  {
    'code': 'EC',
    'value': '+593',
    'display': 'Ecuador (+593)'
  },
  {
    'code': 'IT',
    'value': '+39',
    'display': 'Italy (+39)'
  },
  {
    'code': 'VN',
    'value': '+84',
    'display': 'Vietnam (+84)'
  },
  {
    'code': 'SB',
    'value': '+677',
    'display': 'Solomon Islands (+677)'
  },
  {
    'code': 'ET',
    'value': '+251',
    'display': 'Ethiopia (+251)'
  },
  {
    'code': 'SO',
    'value': '+252',
    'display': 'Somalia (+252)'
  },
  {
    'code': 'ZW',
    'value': '+263',
    'display': 'Zimbabwe (+263)'
  },
  {
    'code': 'SA',
    'value': '+966',
    'display': 'Saudi Arabia (+966)'
  },
  {
    'code': 'ES',
    'value': '+34',
    'display': 'Spain (+34)'
  },
  {
    'code': 'ER',
    'value': '+291',
    'display': 'Eritrea (+291)'
  },
  {
    'code': 'ME',
    'value': '+382',
    'display': 'Montenegro (+382)'
  },
  {
    'code': 'MD',
    'value': '+373',
    'display': 'Moldova (+373)'
  },
  {
    'code': 'MG',
    'value': '+261',
    'display': 'Madagascar (+261)'
  },
  {
    'code': 'MF',
    'value': '+590',
    'display': 'Saint Martin (+590)'
  },
  {
    'code': 'MA',
    'value': '+212',
    'display': 'Morocco (+212)'
  },
  {
    'code': 'MC',
    'value': '+377',
    'display': 'Monaco (+377)'
  },
  {
    'code': 'UZ',
    'value': '+998',
    'display': 'Uzbekistan (+998)'
  },
  {
    'code': 'MM',
    'value': '+95',
    'display': 'Myanmar (+95)'
  },
  {
    'code': 'ML',
    'value': '+223',
    'display': 'Mali (+223)'
  },
  {
    'code': 'MO',
    'value': '+853',
    'display': 'Macao (+853)'
  },
  {
    'code': 'MN',
    'value': '+976',
    'display': 'Mongolia (+976)'
  },
  {
    'code': 'MH',
    'value': '+692',
    'display': 'Marshall Islands (+692)'
  },
  {
    'code': 'MK',
    'value': '+389',
    'display': 'Macedonia (+389)'
  },
  {
    'code': 'MU',
    'value': '+230',
    'display': 'Mauritius (+230)'
  },
  {
    'code': 'MT',
    'value': '+356',
    'display': 'Malta (+356)'
  },
  {
    'code': 'MW',
    'value': '+265',
    'display': 'Malawi (+265)'
  },
  {
    'code': 'MV',
    'value': '+960',
    'display': 'Maldives (+960)'
  },
  {
    'code': 'MQ',
    'value': '+596',
    'display': 'Martinique (+596)'
  },
  {
    'code': 'MP',
    'value': '+1-670',
    'display': 'Northern Mariana Islands (+1-670)'
  },
  {
    'code': 'MS',
    'value': '+1-664',
    'display': 'Montserrat (+1-664)'
  },
  {
    'code': 'MR',
    'value': '+222',
    'display': 'Mauritania (+222)'
  },
  {
    'code': 'IM',
    'value': '+44-1624',
    'display': 'Isle of Man (+44-1624)'
  },
  {
    'code': 'UG',
    'value': '+256',
    'display': 'Uganda (+256)'
  },
  {
    'code': 'TZ',
    'value': '+255',
    'display': 'Tanzania (+255)'
  },
  {
    'code': 'MY',
    'value': '+60',
    'display': 'Malaysia (+60)'
  },
  {
    'code': 'MX',
    'value': '+52',
    'display': 'Mexico (+52)'
  },
  {
    'code': 'IL',
    'value': '+972',
    'display': 'Israel (+972)'
  },
  {
    'code': 'FR',
    'value': '+33',
    'display': 'France (+33)'
  },
  {
    'code': 'IO',
    'value': '+246',
    'display': 'British Indian Ocean Territory (+246)'
  },
  {
    'code': 'SH',
    'value': '+290',
    'display': 'Saint Helena (+290)'
  },
  {
    'code': 'FI',
    'value': '+358',
    'display': 'Finland (+358)'
  },
  {
    'code': 'FJ',
    'value': '+679',
    'display': 'Fiji (+679)'
  },
  {
    'code': 'FK',
    'value': '+500',
    'display': 'Falkland Islands (+500)'
  },
  {
    'code': 'FM',
    'value': '+691',
    'display': 'Micronesia (+691)'
  },
  {
    'code': 'FO',
    'value': '+298',
    'display': 'Faroe Islands (+298)'
  },
  {
    'code': 'NI',
    'value': '+505',
    'display': 'Nicaragua (+505)'
  },
  {
    'code': 'NL',
    'value': '+31',
    'display': 'Netherlands (+31)'
  },
  {
    'code': 'NO',
    'value': '+47',
    'display': 'Norway (+47)'
  },
  {
    'code': 'NA',
    'value': '+264',
    'display': 'Namibia (+264)'
  },
  {
    'code': 'VU',
    'value': '+678',
    'display': 'Vanuatu (+678)'
  },
  {
    'code': 'NC',
    'value': '+687',
    'display': 'New Caledonia (+687)'
  },
  {
    'code': 'NE',
    'value': '+227',
    'display': 'Niger (+227)'
  },
  {
    'code': 'NF',
    'value': '+672',
    'display': 'Norfolk Island (+672)'
  },
  {
    'code': 'NG',
    'value': '+234',
    'display': 'Nigeria (+234)'
  },
  {
    'code': 'NZ',
    'value': '+64',
    'display': 'New Zealand (+64)'
  },
  {
    'code': 'NP',
    'value': '+977',
    'display': 'Nepal (+977)'
  },
  {
    'code': 'NR',
    'value': '+674',
    'display': 'Nauru (+674)'
  },
  {
    'code': 'NU',
    'value': '+683',
    'display': 'Niue (+683)'
  },
  {
    'code': 'CK',
    'value': '+682',
    'display': 'Cook Islands (+682)'
  },
  {
    'code': 'XK',
    'value': '+',
    'display': 'Kosovo (+)'
  },
  {
    'code': 'CI',
    'value': '+225',
    'display': 'Ivory Coast (+225)'
  },
  {
    'code': 'CH',
    'value': '+41',
    'display': 'Switzerland (+41)'
  },
  {
    'code': 'CO',
    'value': '+57',
    'display': 'Colombia (+57)'
  },
  {
    'code': 'CN',
    'value': '+86',
    'display': 'China (+86)'
  },
  {
    'code': 'CM',
    'value': '+237',
    'display': 'Cameroon (+237)'
  },
  {
    'code': 'CL',
    'value': '+56',
    'display': 'Chile (+56)'
  },
  {
    'code': 'CC',
    'value': '+61',
    'display': 'Cocos Islands (+61)'
  },
  {
    'code': 'CA',
    'value': '+1',
    'display': 'Canada (+1)'
  },
  {
    'code': 'CG',
    'value': '+242',
    'display': 'Republic of the Congo (+242)'
  },
  {
    'code': 'CF',
    'value': '+236',
    'display': 'Central African Republic (+236)'
  },
  {
    'code': 'CD',
    'value': '+243',
    'display': 'Democratic Republic of the Congo (+243)'
  },
  {
    'code': 'CZ',
    'value': '+420',
    'display': 'Czech Republic (+420)'
  },
  {
    'code': 'CY',
    'value': '+357',
    'display': 'Cyprus (+357)'
  },
  {
    'code': 'CX',
    'value': '+61',
    'display': 'Christmas Island (+61)'
  },
  {
    'code': 'CR',
    'value': '+506',
    'display': 'Costa Rica (+506)'
  },
  {
    'code': 'CW',
    'value': '+599',
    'display': 'Curacao (+599)'
  },
  {
    'code': 'CV',
    'value': '+238',
    'display': 'Cape Verde (+238)'
  },
  {
    'code': 'CU',
    'value': '+53',
    'display': 'Cuba (+53)'
  },
  {
    'code': 'SZ',
    'value': '+268',
    'display': 'Swaziland (+268)'
  },
  {
    'code': 'SY',
    'value': '+963',
    'display': 'Syria (+963)'
  },
  {
    'code': 'SX',
    'value': '+599',
    'display': 'Sint Maarten (+599)'
  },
  {
    'code': 'KG',
    'value': '+996',
    'display': 'Kyrgyzstan (+996)'
  },
  {
    'code': 'KE',
    'value': '+254',
    'display': 'Kenya (+254)'
  },
  {
    'code': 'SS',
    'value': '+211',
    'display': 'South Sudan (+211)'
  },
  {
    'code': 'SR',
    'value': '+597',
    'display': 'Suriname (+597)'
  },
  {
    'code': 'KI',
    'value': '+686',
    'display': 'Kiribati (+686)'
  },
  {
    'code': 'KH',
    'value': '+855',
    'display': 'Cambodia (+855)'
  },
  {
    'code': 'KN',
    'value': '+1-869',
    'display': 'Saint Kitts and Nevis (+1-869)'
  },
  {
    'code': 'KM',
    'value': '+269',
    'display': 'Comoros (+269)'
  },
  {
    'code': 'ST',
    'value': '+239',
    'display': 'Sao Tome and Principe (+239)'
  },
  {
    'code': 'SK',
    'value': '+421',
    'display': 'Slovakia (+421)'
  },
  {
    'code': 'KR',
    'value': '+82',
    'display': 'South Korea (+82)'
  },
  {
    'code': 'SI',
    'value': '+386',
    'display': 'Slovenia (+386)'
  },
  {
    'code': 'KP',
    'value': '+850',
    'display': 'North Korea (+850)'
  },
  {
    'code': 'KW',
    'value': '+965',
    'display': 'Kuwait (+965)'
  },
  {
    'code': 'SN',
    'value': '+221',
    'display': 'Senegal (+221)'
  },
  {
    'code': 'SM',
    'value': '+378',
    'display': 'San Marino (+378)'
  },
  {
    'code': 'SL',
    'value': '+232',
    'display': 'Sierra Leone (+232)'
  },
  {
    'code': 'SC',
    'value': '+248',
    'display': 'Seychelles (+248)'
  },
  {
    'code': 'KZ',
    'value': '+7',
    'display': 'Kazakhstan (+7)'
  },
  {
    'code': 'KY',
    'value': '+1-345',
    'display': 'Cayman Islands (+1-345)'
  },
  {
    'code': 'SG',
    'value': '+65',
    'display': 'Singapore (+65)'
  },
  {
    'code': 'SE',
    'value': '+46',
    'display': 'Sweden (+46)'
  },
  {
    'code': 'SD',
    'value': '+249',
    'display': 'Sudan (+249)'
  },
  {
    'code': 'DO',
    'value': '+1-809 and 1-829',
    'display': 'Dominican Republic (+1-809 and 1-829)'
  },
  {
    'code': 'DM',
    'value': '+1-767',
    'display': 'Dominica (+1-767)'
  },
  {
    'code': 'DJ',
    'value': '+253',
    'display': 'Djibouti (+253)'
  },
  {
    'code': 'DK',
    'value': '+45',
    'display': 'Denmark (+45)'
  },
  {
    'code': 'VG',
    'value': '+1-284',
    'display': 'British Virgin Islands (+1-284)'
  },
  {
    'code': 'DE',
    'value': '+49',
    'display': 'Germany (+49)'
  },
  {
    'code': 'YE',
    'value': '+967',
    'display': 'Yemen (+967)'
  },
  {
    'code': 'DZ',
    'value': '+213',
    'display': 'Algeria (+213)'
  },
  {
    'code': 'US',
    'value': '+1',
    'display': 'United States (+1)'
  },
  {
    'code': 'UY',
    'value': '+598',
    'display': 'Uruguay (+598)'
  },
  {
    'code': 'YT',
    'value': '+262',
    'display': 'Mayotte (+262)'
  },
  {
    'code': 'UM',
    'value': '+1',
    'display': 'United States Minor Outlying Islands (+1)'
  },
  {
    'code': 'LB',
    'value': '+961',
    'display': 'Lebanon (+961)'
  },
  {
    'code': 'LC',
    'value': '+1-758',
    'display': 'Saint Lucia (+1-758)'
  },
  {
    'code': 'LA',
    'value': '+856',
    'display': 'Laos (+856)'
  },
  {
    'code': 'TV',
    'value': '+688',
    'display': 'Tuvalu (+688)'
  },
  {
    'code': 'TW',
    'value': '+886',
    'display': 'Taiwan (+886)'
  },
  {
    'code': 'TT',
    'value': '+1-868',
    'display': 'Trinidad and Tobago (+1-868)'
  },
  {
    'code': 'TR',
    'value': '+90',
    'display': 'Turkey (+90)'
  },
  {
    'code': 'LK',
    'value': '+94',
    'display': 'Sri Lanka (+94)'
  },
  {
    'code': 'LI',
    'value': '+423',
    'display': 'Liechtenstein (+423)'
  },
  {
    'code': 'LV',
    'value': '+371',
    'display': 'Latvia (+371)'
  },
  {
    'code': 'TO',
    'value': '+676',
    'display': 'Tonga (+676)'
  },
  {
    'code': 'LT',
    'value': '+370',
    'display': 'Lithuania (+370)'
  },
  {
    'code': 'LU',
    'value': '+352',
    'display': 'Luxembourg (+352)'
  },
  {
    'code': 'LR',
    'value': '+231',
    'display': 'Liberia (+231)'
  },
  {
    'code': 'LS',
    'value': '+266',
    'display': 'Lesotho (+266)'
  },
  {
    'code': 'TH',
    'value': '+66',
    'display': 'Thailand (+66)'
  },
  {
    'code': 'TF',
    'value': '+',
    'display': 'French Southern Territories (+)'
  },
  {
    'code': 'TG',
    'value': '+228',
    'display': 'Togo (+228)'
  },
  {
    'code': 'TD',
    'value': '+235',
    'display': 'Chad (+235)'
  },
  {
    'code': 'TC',
    'value': '+1-649',
    'display': 'Turks and Caicos Islands (+1-649)'
  },
  {
    'code': 'LY',
    'value': '+218',
    'display': 'Libya (+218)'
  },
  {
    'code': 'VA',
    'value': '+379',
    'display': 'Vatican (+379)'
  },
  {
    'code': 'VC',
    'value': '+1-784',
    'display': 'Saint Vincent and the Grenadines (+1-784)'
  },
  {
    'code': 'AE',
    'value': '+971',
    'display': 'United Arab Emirates (+971)'
  },
  {
    'code': 'AD',
    'value': '+376',
    'display': 'Andorra (+376)'
  },
  {
    'code': 'AG',
    'value': '+1-268',
    'display': 'Antigua and Barbuda (+1-268)'
  },
  {
    'code': 'AF',
    'value': '+93',
    'display': 'Afghanistan (+93)'
  },
  {
    'code': 'AI',
    'value': '+1-264',
    'display': 'Anguilla (+1-264)'
  },
  {
    'code': 'VI',
    'value': '+1-340',
    'display': 'U.S. Virgin Islands (+1-340)'
  },
  {
    'code': 'IS',
    'value': '+354',
    'display': 'Iceland (+354)'
  },
  {
    'code': 'IR',
    'value': '+98',
    'display': 'Iran (+98)'
  },
  {
    'code': 'AM',
    'value': '+374',
    'display': 'Armenia (+374)'
  },
  {
    'code': 'AL',
    'value': '+355',
    'display': 'Albania (+355)'
  },
  {
    'code': 'AO',
    'value': '+244',
    'display': 'Angola (+244)'
  },
  {
    'code': 'AQ',
    'value': '+',
    'display': 'Antarctica (+)'
  },
  {
    'code': 'AS',
    'value': '+1-684',
    'display': 'American Samoa (+1-684)'
  },
  {
    'code': 'AR',
    'value': '+54',
    'display': 'Argentina (+54)'
  },
  {
    'code': 'AU',
    'value': '+61',
    'display': 'Australia (+61)'
  },
  {
    'code': 'AT',
    'value': '+43',
    'display': 'Austria (+43)'
  },
  {
    'code': 'AW',
    'value': '+297',
    'display': 'Aruba (+297)'
  },
  {
    'code': 'AX',
    'value': '+358-18',
    'display': 'Aland Islands (+358-18)'
  },
  {
    'code': 'AZ',
    'value': '+994',
    'display': 'Azerbaijan (+994)'
  },
  {
    'code': 'IE',
    'value': '+353',
    'display': 'Ireland (+353)'
  },
  {
    'code': 'ID',
    'value': '+62',
    'display': 'Indonesia (+62)'
  },
  {
    'code': 'UA',
    'value': '+380',
    'display': 'Ukraine (+380)'
  },
  {
    'code': 'QA',
    'value': '+974',
    'display': 'Qatar (+974)'
  },
  {
    'code': 'MZ',
    'value': '+258',
    'display': 'Mozambique (+258)'
  }
];